module.exports = __webpack_public_path__ + "img/IconBack.b1fb06c6.svg";